<template>
    <q-dialog v-model="dialogOpen">
        <q-card style="min-width: 420px; max-width: 560px;">
            <q-card-section>
                <div class="text-h6">Send form to client</div>
                <div class="text-body2 text-grey-7 q-mt-xs">
                    {{ form?.title || 'Selected form' }} will be sent to {{ subject?.name || 'the selected client' }}.
                </div>
            </q-card-section>

            <q-separator />

            <q-card-section class="q-gutter-md">
                <q-input :model-value="subject?.email || ''" label="Registered email" outlined dense readonly />
                <q-select
                    v-model="expiryDays"
                    :options="expiryOptions"
                    label="Link expires after"
                    option-label="label"
                    option-value="value"
                    emit-value
                    map-options
                    outlined
                    dense
                />
                <q-banner rounded class="bg-blue-1 text-grey-9">
                    The client can reopen the link until they submit the form or the link expires. Their answers cannot be changed after submission.
                </q-banner>
                <q-banner v-if="error" rounded class="bg-red-1 text-negative">{{ error }}</q-banner>
            </q-card-section>

            <q-card-actions align="right">
                <q-btn flat no-caps label="Cancel" color="grey-8" v-close-popup />
                <q-btn
                    unelevated
                    no-caps
                    label="Send email"
                    color="primary"
                    :loading="sending"
                    :disable="!isValidEmail(subject?.email)"
                    @click="sendInvitation"
                />
            </q-card-actions>
        </q-card>
    </q-dialog>
</template>

<script>
import api from "@/services/api/api";
import { isValidEmail } from "@/services/util/formSubject";

export default {
    name: "ExternalFormInviteDialog",
    emits: ["update:show", "sent"],
    props: {
        show: { type: Boolean, default: false },
        form: { type: Object, default: null },
        subject: { type: Object, default: null },
    },
    data() {
        return {
            dialogOpen: this.show,
            expiryDays: 30,
            sending: false,
            error: null,
            expiryOptions: [
                { label: "7 days", value: 7 },
                { label: "14 days", value: 14 },
                { label: "30 days", value: 30 },
                { label: "60 days", value: 60 },
                { label: "90 days", value: 90 },
            ],
        };
    },
    watch: {
        show(value) {
            this.dialogOpen = value;
            if (value) {
                this.expiryDays = 30;
                this.error = null;
            }
        },
        dialogOpen(value) {
            this.$emit("update:show", value);
        },
    },
    methods: {
        isValidEmail,
        async sendInvitation() {
            if (!this.form?.id || !isValidEmail(this.subject?.email)) return;
            this.sending = true;
            this.error = null;
            try {
                const response = await api.forms.sendExternalFormInvitation(
                    this.form.id,
                    this.subject,
                    this.expiryDays
                );
                this.$emit("sent", response.data);
                this.dialogOpen = false;
            } catch (error) {
                this.error = error.response?.data?.message || "The invitation email could not be sent.";
            } finally {
                this.sending = false;
            }
        },
    },
};
</script>
